var render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',{attrs:{"xmlns":"http://www.w3.org/2000/svg","width":"23","height":"43","viewBox":"0 0 23 43"}},[_c('text',{attrs:{"id":"P","fill":"#f9bd46","font-size":"38","font-family":"Montserrat-Bold, Montserrat","font-weight":"700","letter-spacing":"0.05em"}},[_c('tspan',{attrs:{"x":"0","y":"40"}},[_vm._v("P")])])])
}
var staticRenderFns = []

export { render, staticRenderFns }